import {FuseLoadable} from '@fuse';

export const RpOperationsConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    routes  : [
        {
            path     : '/apps/readypayiaas/RpOperations',
            component: FuseLoadable({
                loader: () => import('./RpOperations')
            })
        },
      
       
      

    ]
};

